<script setup lang="ts">
import {ref, onMounted, useSlots} from 'vue';
import {useRandomUUID} from "~/composables/useRandomUUID";
import {twMerge} from "tailwind-merge";
import {
  breakpointsTailwind,
  useBreakpoints,
} from "@vueuse/core";

const emit = defineEmits(["clickTab"]);


type Props = {
  heading?: string;
  disabled?: boolean;
  headingIcon?: boolean;
  active?: boolean;
  id?: number;
  appendClass?: string;
  headingClass?: string;
  headingBold?: boolean;
  iconName?: string,
  dataTestid?: string;
  iconPos?: "left" | "right";
  alwaysOpen?: boolean;
};
const props = withDefaults(defineProps<Props>(), {
  heading: "",
  disabled: false,
  image: "",
  active: false,
  headingIcon: true,
  appendClass: "",
  headingClass: "",
  headingBold: false,
  iconName: '',
  iconPos: 'right',
  alwaysOpen: false
});
const breakpoints = useBreakpoints(breakpointsTailwind);
const mdAndSmaller = breakpoints.smallerOrEqual("sm");
const isOpen = ref<boolean>(false);

const random_id = ref<string>("");


const toggle = () => {
  if (!props.disabled && !(props.alwaysOpen && !mdAndSmaller.value)) {
    isOpen.value = !isOpen.value;
    emit("clickTab", props.id);
  }
};
</script>

<template>
  <button
      :id="'accordion-tab-' + random_id"
      type="button"
      :class="
      twMerge(
        isOpen ? 'rounded-t-lg' : 'mb-3 rounded-lg',
        !props.alwaysOpen ? 'group w-full p-4 flex relative justify-between items-center gap-3 text-natural-grey font-medium rtl:text-right bg-natural-soft-white':'py-1',
        props.disabled ? 'cursor-not-allowed' : '',
        props.appendClass
      )
    "
    :aria-expanded="isOpen ? 'true' : 'false'"
    :aria-controls="'accordion-tab-body-' + random_id"
    @click="toggle"
    :disabled="props.disabled"
    :data-testid="props.dataTestid"
  >
    <slot name="heading">
      <div class="flex items-center">
        <TsIcon
            data-accordion-icon
            :data-testid="props.dataTestid + 'icon'"
            :class="twMerge(
          'size-6 mr-3 transition-all shrink-0',
            isOpen ? 'rotate-0 text-black' : 'rotate-180'
        )"
            color="currentColor"
            name="pepicons-pop:angle-up"
            v-if="!props.alwaysOpen"
        />
        <span
            :class="twMerge(
            props.disabled && 'text-natural-light-grey',
            props.headingBold && 'font-black',
            'flex items-center gap-2',
            props.headingClass
          )"
        >
        {{ props.heading }}
      </span>
      </div>
    </slot>
    <slot name="thirdElement">
      <TsToggle dataTestid="toggle-organisms"/>
    </slot>
  </button>
  <div
    :id="'accordion-tab-body-' + random_id"
    :aria-labelledby="'accordion-tab-' + random_id"
    :data-collapse="props.alwaysOpen ? 'expand-target' : 'collapse-target'"
    :class="twMerge(
      isOpen ? 'block' : 'hidden'
    )"
  >
    <TsDivider append-class="p-0 m-0 mx-4 before:border-idle-white" />
    <div
        :class="
        twMerge(
          !props.alwaysOpen ? 'px-3 py-4 mb-3 bg-natural-soft-white rounded-b-lg' : 'border-none',
          props.appendClass
        )
      "
    >
      <slot></slot>
    </div>
  </div>
  <slot name="content-middle"></slot>
</template>
